module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_programa_campo.601a276d.jpg";